import { ThemeOptions } from '@mui/material';

/**
 * View Slider props and classes at https://mui.com/material-ui/api/slider/#classes
 */
export const slider: ThemeOptions['components'] = {
  MuiSlider: {
    styleOverrides: {
      valueLabel: ({ theme }) => ({
        backgroundColor: theme.palette.primary.dark,
      }),
    },
  },
};
